import { useState, useEffect, useCallback } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Loader2, Inbox, Check, Mail } from "lucide-react";

export default function Leads() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    const { data } = await api.get("/admin/leads");
    setRows(data); setLoading(false);
  }, []);
  useEffect(() => { load(); }, [load]);

  const toggle = async (id) => { await api.patch(`/admin/leads/${id}`); load(); };
  const fmt = (d) => new Date(d).toLocaleDateString("es-ES", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-heading text-3xl font-bold tracking-tight">Leads de contacto</h1>
        <p className="text-slate-500 text-sm mt-1">Solicitudes recibidas desde la web fichando.app.</p>
      </div>
      <Card className="border-slate-200 shadow-none overflow-hidden">
        {loading ? (
          <div className="h-48 flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-slate-300" /></div>
        ) : !rows.length ? (
          <div className="p-16 text-center text-slate-400"><Inbox className="h-10 w-10 mx-auto mb-3" />Aún no hay solicitudes de contacto.</div>
        ) : (
          <Table>
            <TableHeader><TableRow className="hover:bg-transparent">
              <TableHead>Contacto</TableHead><TableHead>Empresa</TableHead><TableHead>Empleados</TableHead>
              <TableHead>Plan</TableHead><TableHead>Mensaje</TableHead><TableHead>Fecha</TableHead><TableHead className="text-right">Estado</TableHead>
            </TableRow></TableHeader>
            <TableBody>
              {rows.map((l) => (
                <TableRow key={l.id} data-testid={`lead-row-${l.id}`}>
                  <TableCell>
                    <div className="font-medium text-slate-800">{l.name}</div>
                    <div className="text-xs text-slate-400 flex items-center gap-1"><Mail className="h-3 w-3" />{l.email}{l.phone ? ` · ${l.phone}` : ""}</div>
                  </TableCell>
                  <TableCell className="text-slate-600">{l.company || "—"}</TableCell>
                  <TableCell className="text-slate-600">{l.employees || "—"}</TableCell>
                  <TableCell>{l.plan ? <Badge variant="secondary">{l.plan}</Badge> : "—"}</TableCell>
                  <TableCell className="max-w-[240px] truncate text-slate-600" title={l.message}>{l.message || "—"}</TableCell>
                  <TableCell className="text-slate-500 text-sm whitespace-nowrap">{fmt(l.created_at)}</TableCell>
                  <TableCell className="text-right">
                    <Button size="sm" variant={l.status === "contacted" ? "secondary" : "outline"} onClick={() => toggle(l.id)} data-testid={`lead-toggle-${l.id}`}>
                      {l.status === "contacted" ? <><Check className="h-4 w-4 mr-1 text-emerald-600" /> Contactado</> : "Marcar contactado"}
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Card>
    </div>
  );
}
